const awsconfig = {
  'aws_project_region': 'ap-northeast-1',
  'aws_appsync_graphqlEndpoint': 'https://2eo6prlvrbfjvedfufqtjmvk7m.appsync-api.ap-northeast-1.amazonaws.com/graphql',
  'aws_appsync_region': 'ap-northeast-1',
  'aws_appsync_authenticationType': 'AWS_IAM',
  'aws_cognito_identity_pool_id': 'ap-northeast-1:4d67a67f-56c0-493e-9270-5be17e7d99db',
  'aws_cognito_region': 'ap-northeast-1',
  'aws_user_pools_id': 'ap-northeast-1_yw3bfpwir',
  'aws_user_pools_web_client_id': '5fegea1q8vsfmk043me38jehc9',
  'aws_content_delivery_bucket': 'backends-imagebucket6194e37c-kzpj3wu8nfy9',
  'aws_content_delivery_bucket_region': 'ap-northeast-1',
  'aws_content_delivery_url': 'http://backends-imagebucket6194e37c-kzpj3wu8nfy9.s3-website-ap-northeast-1.amazonaws.com',
  'oauth': {}
}
export default awsconfig
